(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zarenva-ingredients"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zarenva-ingredient-gallery')) {
  class ZarenvaIngredientGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.nav = this.querySelector('[data-ingredient-nav]');
      this.links = [...this.querySelectorAll('[data-ingredient-link]')];
      this.panels = [...this.querySelectorAll('[data-ingredient-panel]')];
      if (!this.links.length || this.links.length !== this.panels.length) return;
      this.nav.setAttribute('role', 'tablist');
      this.media = matchMedia('(max-width: 1100px)');
      this.orient = () => this.nav.setAttribute('aria-orientation', this.media.matches ? 'horizontal' : 'vertical');
      this.orient();
      this.media.addEventListener('change', this.orient);
      this.links.forEach((link, index) => {
        link.setAttribute('role', 'tab');
        link.setAttribute('aria-controls', this.panels[index].id);
        link.addEventListener('click', event => {event.preventDefault(); this.activate(index, true);});
        link.addEventListener('keydown', event => this.navigate(event, index, this.links, next => this.activate(next, true)));
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', link.id);
        this.panels[index].tabIndex = 0;
        const panel = this.panels[index];
        const tabs = [...panel.querySelectorAll('[data-chapter-tab]')];
        const chapters = [...panel.querySelectorAll('[data-chapter]')];
        const activateChapter = selected => {
          tabs.forEach((tab, n) => {tab.setAttribute('aria-selected', String(n === selected)); tab.tabIndex = n === selected ? 0 : -1; chapters[n].hidden = n !== selected;});
        };
        panel.querySelector('[data-chapter-nav]').hidden = false;
        panel.querySelector('[data-chapter-nav]').setAttribute('role', 'tablist');
        tabs.forEach((tab, n) => {
          tab.setAttribute('role', 'tab');
          chapters[n].setAttribute('role', 'tabpanel');
          chapters[n].setAttribute('aria-labelledby', tab.id);
          chapters[n].tabIndex = 0;
          tab.addEventListener('click', () => activateChapter(n));
          tab.addEventListener('keydown', event => this.navigate(event, n, tabs, activateChapter));
        });
        activateChapter(0);
        panel.querySelector('[data-pagination]').hidden = false;
        panel.querySelector('[data-previous]').addEventListener('click', () => this.step(-1));
        panel.querySelector('[data-next]').addEventListener('click', () => this.step(1));
      });
      this.hashHandler = () => {const index = this.panels.findIndex(panel => '#' + panel.id === location.hash); if (index >= 0) this.activate(index, false);};
      this.blockHandler = event => {const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId); if (index >= 0) this.activate(index, false);};
      window.addEventListener('hashchange', this.hashHandler);
      document.addEventListener('shopify:block:select', this.blockHandler);
      this.classList.add('is-ready');
      const initial = this.panels.findIndex(panel => '#' + panel.id === location.hash);
      this.activate(initial >= 0 ? initial : 0, false);
    }
    activate(index, updateHash) {
      this.index = index;
      this.links.forEach((link, n) => {link.setAttribute('aria-selected', String(n === index)); link.tabIndex = n === index ? 0 : -1; this.panels[n].hidden = n !== index;});
      if (updateHash) {
        history.replaceState(null, '', '#' + this.panels[index].id);
        if (this.media.matches) {
          const link = this.links[index];
          this.nav.scrollLeft = Math.max(0, link.offsetLeft - this.nav.offsetLeft - 12);
        }
      }
    }
    step(direction) {
      this.activate((this.index + direction + this.panels.length) % this.panels.length, true);
      this.panels[this.index].focus({preventScroll: true});
    }
    navigate(event, index, items, activate) {
      let next;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % items.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + items.length) % items.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = items.length - 1;
      if (event.key === ' ') next = index;
      if (next === undefined) return;
      event.preventDefault(); activate(next); items[next].focus({preventScroll: true});
    }
    disconnectedCallback() {
      window.removeEventListener('hashchange', this.hashHandler);
      document.removeEventListener('shopify:block:select', this.blockHandler);
      if (this.media) this.media.removeEventListener('change', this.orient);
    }
  }
  customElements.define('zarenva-ingredient-gallery', ZarenvaIngredientGallery);
}

  } catch(e) { console.error(e); }
})();
})();
